import {z} from 'zod';

/**
 * Hand-written until the backend endpoint lands in the generated API client. `placeholders`
 * holds codes of the backend `Placeholder` enum, e.g. `CONTACT_PERSON_EMAIL`.
 */
export const GetConsentTemplateMissingPlaceholdersResponseBodySchema = z.object({
  placeholders: z.array(z.string()),
});
export type GetConsentTemplateMissingPlaceholdersApiResponse = z.infer<
  typeof GetConsentTemplateMissingPlaceholdersResponseBodySchema
>;

export const GetConsentTemplateMissingPlaceholdersApiArgSchema = z.object({
  consentTypeId: z.string(),
  templateTitle: z.string(),
  templateFileId: z.string(),
  customerId: z.string(),
  customerContractInformationId: z.string(),
  contactPersonId: z.string().optional(),
});
export type GetConsentTemplateMissingPlaceholdersApiArg = z.infer<
  typeof GetConsentTemplateMissingPlaceholdersApiArgSchema
>;
